<template>
	<div class="search-article" :id="article.link_id">
		<div class="row">
			<div class="col-lg-8">
				<div class="search-article__preview">
					<div class="row">
						<div class="col">
							<h3 :class="{'search-article__title': true, 'search-article__title--visited': article.vueVisited}" @click="openLink">{{ (index + 1) }}. {{ article.title }}</h3>
							<ul class="search-article__meta">
								<li><span>Sou:</span> {{ article.source_url }}</li>
								<li v-if="displayDate != null"><span>Pub:</span> {{ displayDate | moment("YYYY-MM-DD")  }}</li>
								<li v-else><span>Pub:</span> {{ displayDate }}</li>
								<li v-if="searchByFile"><span>Eng:</span> txtFile</li>
								<li v-else><span>Eng:</span> {{ article.search_engine }}</li>
								<li><span>Lan:</span> {{ article.language }}</li>
							</ul>
							<div class="search-article__content">
								{{ transcriptCut }}
							</div>
							<ul class="search-article__keywords">
								<li v-if="article.keyword1 != ''">{{ article.keyword1 }}</li>
								<li v-if="article.keyword2 != ''">{{ article.keyword2 }}</li>
								<li v-if="article.keyword3 != ''">{{ article.keyword3 }}</li>
								<li v-if="article.keyword4 != ''">{{ article.keyword4 }}</li>
								<li v-if="article.keyword5 != ''">{{ article.keyword5 }}</li>
								<li v-if="article.keyword6 != ''">{{ article.keyword6 }}</li>
								<li v-if="article.entity1 != ''" class="entity">{{ article.entity1 }}</li>
								<li v-if="article.entity2 != ''" class="entity">{{ article.entity2 }}</li>
							</ul>
						</div>
						<div class="col-auto">
							<div class="search-article__tags">
								<div
									class="search-article__tag search-article__tag--text"
									:class="{'search-article__tag--active': article.isText}"
								>
									Text
								</div>
								<div
									class="search-article__tag search-article__tag--pdf"
									:class="{'search-article__tag--active': article.isPdf}"
								>
									Pdf
								</div>
								<div
									class="search-article__tag search-article__tag--video"
									:class="{'search-article__tag--active': article.isVideo}"
								>
									Video
								</div>
								<div
									class="search-article__tag search-article__tag--data"
									:class="{'search-article__tag--active': article.isData}"
								>
									Data
								</div>
								<div
									class="search-article__tag search-article__tag--entity"
									:class="{'search-article__tag--active': article.isEntity}"
								>
									Entity
								</div>
								<div
									class="search-article__tag search-article__tag--blocked"
									:class="{'search-article__tag--active': article.isMultilink}"
								>
									Link
								</div>
								<div
									class="search-article__tag search-article__tag--blocked"
									:class="{'search-article__tag--active': article.isBlocked}"
								>
									Blocked
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
			<div class="col-lg-4">
				<div class="search-article__details">
					<h3 class="search-article__details-title">Source Reliability</h3>
					<div class="score">
						<div class="score__bar">
							<div class="score__bar-inner" :style="{backgroundColor: scoreColor, width: (article.source_score * 10) + '%'}">
							</div>
						</div>
						<div class="score__labels">
							<div class="score__label">0</div>
							<div class="score__label">1</div>
							<div class="score__label">2</div>
							<div class="score__label">3</div>
							<div class="score__label">4</div>
							<div class="score__label">5</div>
							<div class="score__label">6</div>
							<div class="score__label">7</div>
							<div class="score__label">8</div>
							<div class="score__label">9</div>
							<div class="score__label">10</div>
						</div>
					</div>
					<h3 class="search-article__details-title">Source Taxonomies</h3>
					<ul class="search-article__taxonomies">
						<li v-for="taxonomy in article.source_taxonomies" :key="taxonomy">{{ getTaxonomyName(taxonomy) }}</li>
					</ul>
					<div v-if="article.source_taxonomies.length == 0" class="search-article__no-taxonomies">
						There are no taxonomies
					</div>
					<div class="text-right">
						<button :class="{'btn': true, 'btn-primary': true, 'search-article-opened': article.vueOpened, 'search-article-saved': article.vueSaved}" @click.prevent="goToLabel()">Label</button>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import { mapGetters } from "vuex";

import { 
	ARTICLE_CURRENT 
} from "../store/actions.type";

import { 
	SET_ARTICLE_VISITED,
	SET_ARTICLE_OPENED,
	SET_ARTICLE_SAVED
} from "../store/mutations.type";

export default {
	name: "SearchArticle",
	props : ['article', 'searchByFile', 'index'],
	data() {
		return {
			displayDate: null,
			transcriptCut: '',
			scoreColor: '#25c8b4'
		}
	},
	computed: {
    ...mapGetters(["taxonomies"]),
  },
	methods: {
		openLink: function() {
			this.article.vueVisited = true;
			this.$store.commit(SET_ARTICLE_VISITED, this.article.link_id);
			window.open(this.article.url);
		},
		trimTranscript: function() {      
			let transcript = this.article.transcript_reviewed;
			if (transcript.length > 400){
				transcript = transcript.substring(0, 400) + "...";
			}
			this.transcriptCut = transcript;      
		},
		goToLabel: function() {
			this.$store.commit(SET_ARTICLE_OPENED, this.article.link_id);
			this.$store.dispatch(ARTICLE_CURRENT, this.article);
			this.$router.push({ name: "Label", params: {
				article: this.article
			}})
		},
		getTaxonomyName: function(taxonomy) {
			for (var i = this.taxonomies.length - 1; i >= 0; i--) {
				if(this.taxonomies[i].tax_id == taxonomy) {
					return this.taxonomies[i].label;
				}
			}
		}
	},
	mounted() {
		this.trimTranscript();

		if(this.article.published_date != null) {
			this.displayDate = this.article.published_date;
		} else if(this.article.modified_date != "null") {
			this.displayDate = this.article.modified_date;
		}

		if(this.article.isReviewed) {
			this.$store.commit(SET_ARTICLE_SAVED, this.article.link_id);
		}
	}
};
</script>

<style lang="scss">
.search-article {
	color: $color-abbey;
	padding-bottom: rem(32px);
	margin-bottom: rem(32px);
	border-bottom: 1px solid #ccc;
	font-family: $font-family-roboto;

	&:last-child {
		margin-bottom: 0;
		padding-bottom: 0;
		border-bottom: 0;
	}

	&__title {
		font-family: $font-family-montserrat;
		text-transform: uppercase;
		font-weight: 700;
		font-size: rem(18px);
		color: $color-genoa;
		margin-bottom: rem(8px);
		transition: color .3s ease;

		&:hover {
			cursor: pointer;
			color: $color-java;
		}
	}

	&__title--visited {
		color: $color-java;
	}

	&__meta {
		margin: 0 0 rem(12px);
		padding: 0;
		list-style: none;

		li {
			display: inline-block;
			font-size: rem(13px);

			span {
				font-weight: 700;
				text-transform: uppercase;
				color: #000;
				font-style: normal;
			}

			&:not(:first-child) {
				padding-left: rem(16px);
			}
		}
	}

	&__content {
		font-size: rem(15px);
		margin-bottom: rem(16px);
	}

	&__keywords {
		margin: 0;
		padding: 0;
		list-style: none;

		li {
			font-family: $font-family-montserrat;
			display: inline-block;
			font-size: rem(12px);
			padding: rem(4px) rem(8px);
			border: 1px solid rgba(0,0,0,.2);
			color: $color-java;
			text-transform: uppercase;

			&:not(:first-child) {
				margin-left: rem(8px);
			}

			&.entity {
				color: $color-genoa;
			}
		}
	}

	&__tags {
		margin: 0;
		padding: 0;
		list-style: none;
		padding-right: rem(20px);
	}

	&__tag {
		font-weight: 700;
		background-color: #f1f1f1;
		text-transform: uppercase;
		padding: rem(4px) rem(12px);
		font-size: rem(12px);
		color: #999;

		&:not(:last-child) {
			margin-bottom: rem(4px);
		}
	}

	&__tag--active {
		background-color: $color-java;
		color: #fff;
	}

	&__details-title {
		font-family: $font-family-montserrat;
		text-align: center;
		font-size: rem(16px);
		color: #000;
		text-transform: uppercase;
		font-weight: 700;
		margin-bottom: rem(12px);
	}

	&__no-taxonomies {
		font-size: rem(12px);
		text-align: center;
		margin-bottom: rem(16px);
	}

	&__taxonomies {
		margin: 0;
		padding: 0;
		list-style: none;

		li {
			font-family: $font-family-montserrat;
			display: inline-block;
			font-size: rem(12px);
			padding: rem(4px) rem(8px);
			border: 1px solid rgba(0,0,0,.2);
			color: $color-java;
			text-transform: uppercase;

			&:not(:first-child) {
				margin-left: rem(8px);
			}
		}
	}
}

.search-article-opened {
	background-color: $color-java !important;
	border-color: $color-java !important;

	&:hover {
		background-color: $color-java !important;
		border-color: $color-java !important;
	}
}

.search-article-saved {
	background-color: #555 !important;
	border-color: #555 !important;

	&:hover {
		background-color: $color-java !important;
		border-color: $color-java !important;
	}
}

.score {
	font-family: $font-family-roboto;
	
	&__bar {
		position: relative;
		background: #f1f1f1;
	}

	&__bar-inner {
		width: 100%;
		height: rem(30px);
	}

	&__labels {
		display: flex;
		justify-content: space-between;
		margin-left: -3px;
		margin-right: -6px;
		margin-bottom: rem(16px);
	}

	&__label {
		position: relative;
		padding-top: 12px;
		font-size: rem(12px);
		font-weight: 700;
		color: #000;

		&:before {
			content: '';
			width: 1px;
			height: 10px;
			background-color: rgba(0,0,0,.3);
			position: absolute;
			left: 50%;
			top: 0;
		}
	}
}
</style>